import { jsx, jsxs } from "react/jsx-runtime";
import { Skeleton } from "@pcln/horizon";
import "react";
const HotelLoadingSkeletonComponent = ({ isMobile })=>{
    const count = isMobile ? 2 : 5;
    const skeletons = Array(count).fill(0).map((_, index)=>/*#__PURE__*/ jsxs("div", {
            className: "border-neutral-5 mb-6 h-[330px] w-[239px] flex-shrink-0 flex-row overflow-hidden rounded-xl border",
            children: [
                /*#__PURE__*/ jsx("div", {
                    className: "h-[123px] w-[239px]",
                    children: /*#__PURE__*/ jsx(Skeleton, {
                        type: "image",
                        className: "h-full w-full rounded-t-xl",
                        animate: true
                    })
                }),
                /*#__PURE__*/ jsxs("div", {
                    className: "border-neutral-5 flex w-[239px] flex-col justify-between gap-2 p-4",
                    children: [
                        /*#__PURE__*/ jsx("div", {
                            className: "mb-4",
                            children: /*#__PURE__*/ jsx(Skeleton, {
                                type: "h4",
                                className: "w-full",
                                animate: true
                            })
                        }),
                        /*#__PURE__*/ jsx("div", {
                            className: "mb-4",
                            children: /*#__PURE__*/ jsx(Skeleton, {
                                type: "body3",
                                width: 151,
                                height: 12
                            })
                        }),
                        /*#__PURE__*/ jsx(Skeleton, {
                            type: "body3",
                            width: 88,
                            height: 12
                        }),
                        /*#__PURE__*/ jsx(Skeleton, {
                            type: "body3",
                            width: 236,
                            height: 12
                        }),
                        /*#__PURE__*/ jsxs("div", {
                            className: "mt-4 flex items-center gap-1",
                            children: [
                                /*#__PURE__*/ jsx(Skeleton, {
                                    type: "btn_lg",
                                    width: 40,
                                    height: 24
                                }),
                                /*#__PURE__*/ jsx(Skeleton, {
                                    type: "body3",
                                    width: 83
                                }),
                                /*#__PURE__*/ jsx(Skeleton, {
                                    type: "body3",
                                    width: 63
                                })
                            ]
                        })
                    ]
                })
            ]
        }, `hotel-loading-skeleton-${index}`));
    return /*#__PURE__*/ jsx("div", {
        className: "flex w-full flex-row gap-3 overflow-hidden px-4",
        children: skeletons
    });
};
export { HotelLoadingSkeletonComponent };
